export default __webpack_public_path__ + "static/2-0c46c2aaa12de9779fa0f1420ded9557.png";